// Each form input
import InputComponent from './Input'

// Connects field to redux-forms
import FieldWrapper from './FieldWrapper'

// Wrap and export fields
export const Input = FieldWrapper(InputComponent)